import $ from 'jquery';

export default function bind() {
  $('.back-button').on('click', evt => {
    evt.preventDefault();
    history.back();
    return true;
  });
}



// WEBPACK FOOTER //
// ./src/plugins/back-button.js